module.exports = __webpack_public_path__ + "img/KevinScanlon.7e8e065e.jpg";